import { Bell } from "lucide-react";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../shadcn/components/ui/Avatar";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate

export function Topbar({ section, mainSection }) {
  const [username, setUsername] = useState("");
  const [role, setRole] = useState(""); // State for role
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch user details from localStorage
    const storedName = localStorage.getItem("name");
    const storedRole = localStorage.getItem("userRole"); // Get role from localStorage

    if (storedName) {
      setUsername(storedName);
    }
    if (storedRole) {
      setRole(storedRole);
    }
  }, []);

  // Handle notification click based on rolee
  const handleNotificationClick = () => {
    switch (role) {
      case "Individual":
        navigate("/dashboard/Notification");
        break;
      case "Property Owner":
        navigate("/propertyownerdashboard/Notification");
        break;
      case "Hospital System/Managed Care Organizations":
        navigate("/HospitalManagement/Notification");
        break;
      case "Real Estate Professionals":
        navigate("/realestatedashboard/Notification");
        break;
      case "Service Provider":
        navigate("/servicedashboard/Notification");
        break;
      case "Non Profits":
        navigate("/nonprofit/Notification");
        break;
      default:
        navigate("/Notification");
    }
  };

  return (
    <div className="flex h-16 items-center justify-between border-b px-5 lg:px-10 w-full">
      <div className="flex items-center gap-4">
        <h1 className="text-sm md:text-xl font-semibold capitalize">
          {section || mainSection}
        </h1>
      </div>
      <div className="flex items-center gap-4">
        {/* Notification Bell */}
        <button
          className="rounded-full p-2 hover:bg-accent"
          onClick={handleNotificationClick}
        >
          <Bell className="h-4 w-4" />
        </button>

        {/* User Avatar */}
        <div className="flex items-center gap-2">
          <Avatar>
            <AvatarImage src="/placeholder.svg?height=32&width=32" />
            <AvatarFallback>
              {username ? username.charAt(0).toUpperCase() : "U"}
            </AvatarFallback>
          </Avatar>
          <div className="text-sm">
            <p className="font-medium text-xs md:text-sm">
              {username || "Unknown User"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
